import { render, staticRenderFns } from "./modalSignandSave.vue?vue&type=template&id=228c9f24&"
import script from "./modalSignandSave.vue?vue&type=script&lang=js&"
export * from "./modalSignandSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports